import { createFileRoute } from "@tanstack/react-router";
import Page from "./-page";

export const Route = createFileRoute(
  "/_private/_inventory-360/inventory/$inventoryId/lot/$lotNumber",
)({
  component: LotDetailsRoute,
});

function LotDetailsRoute() {
  const { inventoryId, lotNumber } = Route.useParams();
  return <Page inventoryId={inventoryId} lotNumber={lotNumber} />;
}
